<template lang="html">

  <transition name="modal">
    <div class="pe_modal-mask" @click="$emit('close')">
      <div class="pe_modal-container" @click.stop>

        <div class="pe_modal-header" v-if="header !== false">
          <h2 class="pe_title">
            <slot name="title"></slot>
          </h2>
          <button 
            v-if="closeBtn !== false"
            class="pe_btn pe_close-btn" 
            @click="$emit('close-x')"
          >
            <icon-cross />
          </button>
        </div>

        <div class="pe_modal-body">
          <slot name="body"></slot>
        </div>

        <div class="pe_modal-footer" v-if="footer !== false">
          <button 
            class="pe_btn pe_submit" 
            @click="$emit('close')">
            <slot name="footer">Submit</slot>   
          </button>
        </div>

      </div>
    </div>
  </transition>

</template>

<script lang="js">

  import Cross from '@puzzleapps/shared/src/components/ui/icons/Cross'

  export default  {
    name: 'modal',
    props: ['header', 'footer', 'closeBtn'],
    components: {
      'icon-cross': Cross,
    }
  }

</script>

<style scoped lang="scss">

@import '@puzzleapps/shared/src/style/variables';

#puzzleapp {
  .pe_modal-mask {
    position: absolute;
    z-index: 9998;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;

    @media (min-width: 500px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .pe_submit {
    width: 100%;
    background: var(--secondary-background-color);
    padding: 0.8em;
  }

  .pe_close-btn {
    position: absolute;
    right: 0.8em;
    top: 0.8em;
    width: 1em;
    height: 1em;
    cursor: pointer;
    padding: 0;
  }

  .pe_modal-container {
    width: calc(100% - 30px);
    margin: 15px;
    // padding: 20px 30px;
    background: var(--secondary-background-color);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    
    @media (min-width: 500px) {
      width: 300px;
    }
  }

  .pe_modal-header {
    background: var(--secondary-background-color);
    border-bottom: 1px solid #ebebeb;
    padding: 0.8em;
    position: relative;
  }

  .pe_title {
    font-family: $primary-font;
    font-size: 1em!important;
    margin: 0;
    font-weight: 500;
    letter-spacing: 1px;    
  }

  .pe_modal-body {
    margin: 20px;
  }

  .pe_modal-enter {
    opacity: 0;
  }

  .pe_modal-leave-active {
    opacity: 0;
  }

  .pe_modal-enter .pe_modal-container,
  .pe_modal-leave-active .pe_modal-container {
    transform: scale(1.1);
  }
}
</style>
